import { render, staticRenderFns } from "./NotificationToOmtk.vue?vue&type=template&id=e64a18e6"
import script from "./NotificationToOmtk.vue?vue&type=script&lang=js"
export * from "./NotificationToOmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports